import React, { useState, useRef } from 'react'
import { Form, Container, Card, Row, Col, Alert } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import emailjs from "emailjs-com"


export default function Contact() {

    const form = useRef();
    const [service1, setService1] = useState(false);
    const [service2, setService2] = useState(false);
    const [service3, setService3] = useState(false);
    const [service4, setService4] = useState(false);
    const [service5, setService5] = useState(false);
    const [error, setError] = useState('')
    const [message, setMessage] = useState('')
    const [loading] = useState(false)

    const handleOnChange = () => {
        setService1(!service1);
    };

    const handleOnChange2 = () => {
        setService2(!service2);
      };

    const handleOnChange3 = () => {
    setService3(!service3);
    };
    
    const handleOnChange4 = () => {
    setService4(!service4);
    };

    const handleOnChange5 = () => {
    setService5(!service5);
    };

    const SendEmail = (e) => {
        e.preventDefault();
        setMessage('')

        emailjs.sendForm('service_m1mjmlf', 'template_servicios', form.current, 'user_xt6pT4sjFRdD5wMTsyNld')
          .then((result) => {
              setMessage('Tu solicitud ha sido enviada, pronto nos comunicaremos con vos')
          }, (error) => {
            setError('No pudimos enviar tu mensaje, intenta luego')
          });
          e.target.reset();
        
    }


    return (
        <>
         <div className="site-wraper overflow-hidden position-relative">
            <Header/>
            <Container className="d-flex" style={{minHeight:"100vh"}}>
                <div className="container h-100 my-3">
                    <div className="row d-flex justify-content-center align-items-center h-100 mx-auto" style={{maxWidth:"800px"}}>
                        <div className="col-xl-12">
                            <div className="row g-0 d-flex">
                                    <Card className="rounded-start">
                                        <Card.Body className="p-5 rounded-start">
                                            <h2 className="text-center mb-2" style={{color: '#ffa900'}} >Solicita tu servicio</h2>
                                            {message && <Alert variant="warning">{message}</Alert>}
                                            {error && <Alert variant="danger">{error}</Alert>}
                                            <Form ref={form} onSubmit={SendEmail}>
                                            <Row className="mb-1">
                                                <Form.Group as={Col} id="name">
                                                    <Form.Label>Nombre</Form.Label>
                                                    <Form.Control type="text" required name="name"/>
                                                </Form.Group>
                                                <Form.Group as={Col} id="lastName">
                                                    <Form.Label>Apellido</Form.Label>
                                                    <Form.Control type="text" required name="lastName"/>
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-1">
                                                <Form.Group as={Col} id="id">
                                                    <Form.Label>DNI / ID</Form.Label>
                                                    <Form.Control type="number"  required name="id" />
                                                </Form.Group>
                                                <Form.Group as={Col} id="phone">
                                                    <Form.Label>Telefono</Form.Label>
                                                    <Form.Control type="tel"  required name="phone" />
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-1">
                                                <Form.Group as={Col} id="adress">
                                                    <Form.Label>Dirección</Form.Label>
                                                    <Form.Control type="text"  required name="address"/>
                                                </Form.Group>
                                                <Form.Group as={Col} id="country">
                                                    <Form.Label>País</Form.Label>
                                                    <Form.Control type="text"  required name="country"/>
                                                </Form.Group>
                                            </Row>

                                                <Form.Group id="services">
                                                    <Form.Label>Servicios a solicitar</Form.Label>
                                                        <div  className="mb-3">
                                                            <Form.Check
                                                                inline
                                                                label="Trading"
                                                                name="service1"
                                                                type="checkbox"
                                                                id={`inline-checkbox-1`}
                                                                value={"Trading"}
                                                                checked={service1}
                                                                onChange={handleOnChange}
                                                            />
                                                            <Form.Check
                                                                inline
                                                                label="Minería"
                                                                name="service2"
                                                                type="checkbox"
                                                                id={`inline-checkbox-2`}
                                                                value={"Minería"}
                                                                checked={service2}
                                                                onChange={handleOnChange2}
                                                            />
                                                            <Form.Check
                                                                inline
                                                                name="service3"
                                                                label="Educación"
                                                                type="checkbox"
                                                                id={`inline-checkbox-3`}
                                                                value={"Educación"}
                                                                checked={service3}
                                                                onChange={handleOnChange3}
                                                            />
                                                            <Form.Check
                                                                inline
                                                                name="service3"
                                                                label="Fondeo P2P"
                                                                type="checkbox"
                                                                id={`inline-checkbox-4`}
                                                                value={"Educación"}
                                                                checked={service4}
                                                                onChange={handleOnChange4}
                                                            />
                                                            <Form.Check
                                                                inline
                                                                name="service3"
                                                                label="Enviar dinero"
                                                                type="checkbox"
                                                                id={`inline-checkbox-5`}
                                                                value={"Educación"}
                                                                checked={service5}
                                                                onChange={handleOnChange5}
                                                            />
                                                        </div>
                                                </Form.Group>
                                                <button  className="w-100 mt-3 nav__btn btn-block fa-lg mb-3"  type="submit" style={{background: loading ? "#ffa901ab" : "#ffa901"}}>Enviar</button>
                                            </Form>
                                            <div className="w-100 text-center mt-2">
                                                <Link to="/" style={{color: '#ffa900'}}>Salir</Link>
                                            </div>
                                        </Card.Body>
                                    </Card>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
            <Footer/>
      </div>
    </>
    )
}
